import React from "react";
import {
  Home,
  Sparkles,
  ShieldCheck,
  Award,
  Wrench,
  Heart,
  DollarSign,
  Clock,
} from "lucide-react";

const items = [
  { Icon: Home, title: "We Come To You", desc: "Home, office or anywhere convenient." },
  { Icon: Sparkles, title: "Premium Products", desc: "Professional-grade pH-neutral chemistry." },
  { Icon: Wrench, title: "Fully Equipped Setup", desc: "Self-contained mobile detailing rig." },
  { Icon: Award, title: "Experienced Detailers", desc: "Trained, careful, methodical work." },
  { Icon: ShieldCheck, title: "Satisfaction Guaranteed", desc: "We're not finished until you are." },
  { Icon: Heart, title: "Attention To Detail", desc: "Care that exceeds expectations." },
  { Icon: DollarSign, title: "Affordable Premium", desc: "Luxury results at fair pricing." },
  { Icon: Clock, title: "Reliable Appointments", desc: "On time. Every time." },
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-section"
      className="section bg-[color:var(--bg)] relative"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col gap-6 lg:grid lg:grid-cols-12 lg:items-end mb-12">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-3 mb-6 reveal">
              <span className="diamond-divider" />
              <span className="overline">Why Choose Us</span>
            </div>
            <h2 className="reveal font-display tracking-tight text-neutral-900 text-4xl md:text-5xl leading-tight">
              Eight reasons drivers
              <br />
              <span className="text-neutral-500 font-light italic">come back to us.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-200">
          {items.map((it) => (
            <div
              key={it.title}
              data-testid={`why-item-${it.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-white hover:bg-neutral-50 transition-colors p-7 md:p-8 reveal"
            >
              <it.Icon
                size={22}
                strokeWidth={1.5}
                className="text-[color:var(--accent)]"
              />
              <div className="font-display text-neutral-900 text-lg font-semibold mt-5">
                {it.title}
              </div>
              <div className="text-neutral-500 text-sm mt-2 leading-relaxed">
                {it.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
